<template>
  <div class="row" style="margin-top: 20px">
    <div class="col-md-12 text-center">
      <div class="d-flex justify-content-center" role="group" aria-label="Basic example">
        <button type="button" style="margin-right:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='usuarios','btn-outline-secondary': abaSelecionada!=='usuarios' }" @click="trocarAba('usuarios')">Usuarios</button>
        <button v-if="retornaSite() !== 'Stream1x2'"  type="button" style="margin-right:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='planos','btn-outline-secondary': abaSelecionada!=='planos' }" @click="trocarAba('planos')">Planos</button>
        <button type="button" style="margin-right:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='planos-lancamentos','btn-outline-secondary': abaSelecionada!=='planos-lancamentos' }" @click="trocarAba('planos-lancamentos')">Planos Lan.</button>
        <button v-if="retornaSite() !== '7live' && retornaSite() !== 'Stream1x2'" type="button" style="margin-right:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='pay-admin','btn-outline-secondary': abaSelecionada!=='pay-admin' }" @click="trocarAba('pay-admin')">Pay</button>
        <button v-if="retornaSite() == '7live'" type="button" style="margin-right:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='creditos-lancamentos','btn-outline-secondary': abaSelecionada!=='creditos-lancamentos' }" @click="trocarAba('creditos-lancamentos')">Creditos Lan.</button>
        <button v-if="retornaSite() == '7live'" type="button" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='eventos-lancamentos','btn-outline-secondary': abaSelecionada!=='eventos-lancamentos' }" @click="trocarAba('eventos-lancamentos')">Eventos Lan.</button>
        <button v-if="retornaSite() == '7live'" type="button" style="margin-left:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='planos-finalizados','btn-outline-secondary': abaSelecionada!=='planos-finalizados' }" @click="trocarAba('planos-finalizados')">Comissão</button>
      </div>
      <div v-bind:style="{display: (abaSelecionada=='usuarios' ? 'block' : 'none')}" >
        <ListUsuarios />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='planos' ? 'block' : 'none')}" >
        <ListPlanos />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='creditos-lancamentos' ? 'block' : 'none')}" >
       <ListCreditosUsuario ref="listCreditosUsuario" :propView="'completo'" style="margin-top:30px" />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='planos-lancamentos' ? 'block' : 'none')}" >
       <ListPlanosCliente ref="listPlanosCliente" :propView="'completo'" style="margin-top:30px" />
      </div> 
      <div v-bind:style="{display: (abaSelecionada=='eventos-lancamentos' ? 'block' : 'none')}" >
       <ListEventosUsuario ref="listEventosUsuario" :propView="'completo'" style="margin-top:30px" />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='planos-finalizados' ? 'block' : 'none')}" >
       <ListPlanosFinalizados ref="listPlanosFinalizados" :propView="'completo'" style="margin-top:30px" />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='pay-admin' ? 'block' : 'none')}" >
       <ListPayAdmin ref="listPayAdmin" :propView="'completo'" style="margin-top:30px" />
      </div>
    </div>
  </div>
</template>

<script>
import ListUsuarios from "../lists/ListUsuarios";
import ListPlanos from "../lists/ListPlanos";
import ListPlanosCliente from "../lists/ListPlanosCliente";
import ListPayAdmin from "../lists/ListPayAdmin";
import ListPlanosFinalizados from "../lists/ListPlanosFinalizados";
import ListCreditosUsuario from "../lists/ListCreditosUsuario";
import ListEventosUsuario from "../lists/ListEventosUsuario";


export default {
  name: "Administracao",
  components: { ListPayAdmin, ListUsuarios, ListPlanos, ListPlanosCliente,ListPlanosFinalizados, ListCreditosUsuario, ListEventosUsuario },
  methods: {
    trocarAba(aba) {

      if(aba == "creditos-lancamentos")
      {
        this.$refs.listCreditosUsuario.carregarItens();    
      }else if(aba == "planos-lancamentos")
      {
        this.$refs.listPlanosCliente.carregarItens();
      }else if(aba == "eventos-lancamentos")
      {
        this.$refs.listEventosUsuario.carregarItens();
      }else if(aba == "planos-finalizados"){
        this.$refs.listPlanosFinalizados.carregarItens();
      }else if(aba == "pay-admin"){
        this.$refs.listPayAdmin.carregarItens();
      }

      this.abaSelecionada = aba;
    },
    retornaSite()
    {
      return this.$site;
    }
  },
  data: function () {
    return {
      abaSelecionada: "resumo",
      isAdmin:false
    };
  },
  async mounted(){

    this.isAdmin = this.$sessao.usuario.tipoUsuario == "Administrador";
    this.abaSelecionada = "usuarios";

  }
};
</script>

<style>
</style>